import {
    AsyncOperationId,
    AsyncOperationStatus,
    isAsyncOperationTerminal,
} from "@sp-crm/core";
import { useEffect, useRef } from "react";
import { QueryClient } from "react-query";
import { refreshFeedWhenSendSettles } from "store/actions/email";

export const useRefreshFeedWhenSendSettles = (
    operationId: AsyncOperationId | null,
    status: AsyncOperationStatus | null,
    queryClient: QueryClient,
): void => {
    const statusRef = useRef(status);
    useEffect(() => {
        statusRef.current = status;
    }, [status]);
    useEffect(() => {
        return () => {
            if (
                operationId !== null &&
                (statusRef.current === null ||
                    !isAsyncOperationTerminal(statusRef.current))
            ) {
                void refreshFeedWhenSendSettles(operationId, queryClient);
            }
        };
    }, [operationId, queryClient]);
};
